import styled from 'styled-components';

import { COLOR_RED, COLOR_ORANGE, COLOR_BLACK } from '../../../assets/styles/colors';
import { rgba } from 'polished';

export default styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span {
    font-size: 14px;
    margin-bottom: 0;
    color: ${rgba(COLOR_BLACK, 0.6)};
    /* font-weight: bold; */
    display: inline-block;
    text-transform: uppercase;
    a {
      font-size: 14px;
      margin-bottom: 0;
      color: ${rgba(COLOR_BLACK, 0.6)};
      font-weight: bold;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  small,
  span {
    max-width: 530px;

    margin-top: 4px;
    display: block;
    color: rgba(47, 46, 65, 0.6);
    font-family: 'Source Sans Pro';
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;

    &.link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
export const CheckboxSC = styled.label`
  ${(props) =>
    props.hasError
      ? '.ch-circle {border: 1px solid #F71D1D !important;}'
      : '.ch-circle {border:none;}'};
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  width: fit-content;

  input {
    display: none;
  }

  .ch-circle,
  .ch-label {
    display: inline-block;
    vertical-align: middle;
  }

  .ch-label {
    font-size: 18px;
    color: ${({ theme }) => COLOR_BLACK};

    ${({ type, theme }) => {
      if (type === 'DISABLED') {
        return 'color: rgba(47,46,65,0.2);';
      }
      if (type === 'READONLY') {
        return 'color: rgba(47,46,65,0.5)';
      }
      if (type === 'ERROR') {
        return `color: ${COLOR_RED};`;
      }
    }}
  }

  .ch-circle {
    position: relative;
    min-width: 24px;
    min-height: 24px;
    height: 24px;
    width: 24px;
    border: none;
    background: rgba(47, 46, 65, 0.15);
    border-radius: 8px;
    margin-right: 14px;
    text-align: center;

    img {
      z-index: 9;
      position: relative;
      margin-bottom: 0px;
      vertical-align: initial;
      display: ${({ active }) => (active ? 'initial' : 'none')};
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 8px;
      min-width: 24px;
      min-height: 24px;
      height: 24px;
      width: 24px;
    }

    ${({ active, type, theme }) => {
      if (type === 'DISABLED') {
        return `
        border-color: #e5e5e8;
        &:after {
          background: #e5e5e8;
        }`;
      }
      if (type === 'READONLY') {
        return `
        &:after {
          background: #ababb3;
        }`;
      }
      if (type === 'ERROR') {
        return `
        border-color: ${COLOR_RED}`;
      }
      if (active) {
        return `
        border-color: ${COLOR_ORANGE};
        &:after {
          background: ${COLOR_ORANGE};
        }`;
      }
    }}
  }
`;
